import React from 'react'
import { trans } from '../../../../../Internationalization'

function WorkForm() {
  return (
    <div>{trans("emp_wo_fo")}</div>
  )
}

export default WorkForm